/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRecordMailOff = createReactComponent("record-mail-off", "IconRecordMailOff", [
  ["path", { d: "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M18.569 14.557a3 3 0 1 0 -4.113 -4.149", key: "svg-1" }],
  ["path", { d: "M7 15h8", key: "svg-2" }],
  ["path", { d: "M3 3l18 18", key: "svg-3" }]
]);

export { IconRecordMailOff as default };
//# sourceMappingURL=IconRecordMailOff.js.map
